import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { toggleFolioNav } from '../../actions/folio-actions';
import MobileMenu from '../MobileMenu/MobileMenu';
import styled from 'styled-components';
import { routes } from '../../constants';
import { Link } from 'react-router-dom';
import StyledLink from '../StyledLink';

import { connect } from 'react-redux'
import logo from '../../images/logo.jpg';

const HeaderWrapper = styled.div`
  background: ${({ theme }) => theme.colors.secondary };
  font-family: Alegreya, serif;
  position: fixed;
  text-align: left;
  top: 0;
  max-width: 100vw;
  width: 100%;
  z-index: 1000;

  .mobile {
    width: 100%;
  }

  .mobile-title {
    color: ${({ theme }) => theme.colors.primary };
    font-size: 20px;
    width: 100%;
  }

  .mobile-menu {
    position: absolute;
    top: 10px;
    right: 20px;

    &__menu {
      background-color: ${({ theme }) => theme.colors.primary };
      padding: 0 0 10px 0;
      position: absolute;
      top: 50px;
      width: 100%;
      
      ul {
        padding: 0;
      }

      li {
        display: block;

        a {
          color: ${({ theme }) => theme.colors.secondary };
        }
      }

      li:nth-child(2) {
        display: block;
      }
    }
  }
`;

const Logo = styled.img`
  height: 50px;
  float: left;
  width: auto;

  @media (min-width: 769px) {
    height: 100px;
  }
`;

const Nav = styled.div`
  line-height: 50px;
  position: absolute;
  text-align: center;
  top: 0;
  width: 100%;

  @media (min-width: 769px) {
    display: block;
    left: 120px;
    line-height: 100px;
    width: auto;
  }
`;

const Menu = styled.ul`
    display: flex;
    margin: 0;
    padding: 0;
    text-align: left;
    width: calc(100vw - 140px);

    @media (max-width: 769px) {
      li:nth-child(2) {
        display: none;
      }
    }

  li {
    list-style: none;
    display: block;
    font-size: 18px;
    padding: 0 12px;
  }
`;

const UserName = styled.div`
    position: absolute;
    right: 10px;
    top: 41px;
    
    @media (max-width: 769px) {
      display: none;
    }
`;

const FakeLink = styled.span`
  cursor: pointer;
  color: #9c312a;
  
  &:before {
    content: "|";
    display: inline-block;
    margin: 0 5px;
  }
`;

const MainNavLink = styled(StyledLink)`
    cursor: pointer;

    @media (min-width: 769px) {
      padding: 35px 0;
    }

    &:hover {
      border-bottom: 4px solid #ab3029;
    }
`;

const ContactLink = styled(MainNavLink)`
    @media (max-width: 769px) {
      display: none;
    }
`;

const ContactItem = styled.li`
  text-align: right;
  flex-grow: 2;
`

class Header extends React.Component {

  state = {
    showMobile: false
  };

  handleFolioClick = (e) => {
    e.preventDefault();
    this.props.navFolio();
    this.setState(() => ({ showMobile: false }));
  };

  handleLoginClick = () => {
    this.props.navAdmin();
  };

  handleHomeClick = () => {
    this.props.navHome();
  };

  handleMobileClick = () => {
    this.setState(() => ({ showMobile: false }))
  };

  handleMobileMenu = () => {
    this.setState(() => ({ showMobile: true }))
  };


  // todo - get rid of this
  viewportHeight = window.innerHeight;
  viewportWidth = window.innerWidth;
  ratio = (this.viewportWidth * 9) / 16;
  factor = window.innerWidth / window.innerHeight;
  isPortrait = this.factor < 1;
  size = this.isPortrait ? this.viewportHeight - (this.viewportHeight * this.factor) + 'px' : this.ratio - this.viewportWidth;


  render() {

    const { username, deviceType } = this.props;

    return (
        <HeaderWrapper className="header">
          <Link to={ routes.HOME }><Logo alt="Chevo studios" src={ logo } /></Link>
          <Nav className={ deviceType === 'mobile' ? 'mobile' : 'desktop' }>
            { deviceType !== "mobile" ?
                <Menu className="menu">
                  <li><MainNavLink to={ routes.FOLIO }>Explore Our Work</MainNavLink></li>
                  <li><MainNavLink to={ routes.ABOUT }>Inside Chevo Studios</MainNavLink></li>
                  <li><MainNavLink to={ routes.PROCESS }>The Way We Work</MainNavLink></li>
                  { !username && <ContactItem><ContactLink to={ routes.CONTACT }>Contact us</ContactLink></ContactItem> }
                </Menu> :
                <MobileMenu showMobile={ this.state.showMobile }
                            handleFolioClick={ this.handleFolioClick }
                            handleMobileClick={ this.handleMobileClick }
                            handleMobileMenu={ this.handleMobileMenu }
                            handleHomeClick={ this.handleHomeClick }
                            navAbout={ this.props.navAbout }
                            navFolio={ this.props.navFolio }
                            navProcess={ this.props.navProcess }
                            navContact={ this.props.navContact }
                />
            }
          </Nav>
          { username &&
          <UserName>
            <StyledLink to={ `${routes.ADMIN}/projects` }>Admin</StyledLink>
            <FakeLink onClick={ () => { this.props.logout(); } }>Logout</FakeLink>
          </UserName> }
        </HeaderWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  navAbout: () => push(routes.ABOUT),
  navAdmin: () => push(routes.ADMIN),
  navHome: () => push(routes.HOME),
  navFolio: () => push(routes.FOLIO),
  navProcess: () => push(routes.PROCESS),
  navContact: () => push(routes.CONTACT),
  navLogout: () => push(routes.LOGOUT),
  toggleFolioNav: toggleFolioNav
}, dispatch);

Header.propTypes = {
  deviceType: PropTypes.string,
  navAdmin: PropTypes.func.isRequired,
  navProcess: PropTypes.func.isRequired,
  navFolio: PropTypes.func.isRequired,
  navHome: PropTypes.func.isRequired,
  navAbout: PropTypes.func.isRequired,
  navLogout: PropTypes.func.isRequired,
  username: PropTypes.string,
  toggleFolioNav: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js